import { render, staticRenderFns } from "./areaMaim.vue?vue&type=template&id=ff98298a&scoped=true"
import script from "./areaMaim.vue?vue&type=script&lang=js"
export * from "./areaMaim.vue?vue&type=script&lang=js"
import style0 from "./areaMaim.vue?vue&type=style&index=0&id=ff98298a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff98298a",
  null
  
)

export default component.exports